import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";

const CREST_URL = "https://customer-assets.emergentagent.com/job_career-hub-538/artifacts/li6pjilk_LC-Crest-%28Transparent%29.png";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/staff" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/staff");
    else setError(res.error);
  };

  return (
    <Layout variant="public">
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="brut-card-static p-8" data-testid="login-card">
          <div className="text-center mb-6">
            <img src={CREST_URL} alt="School crest" className="h-20 w-20 mx-auto mb-3 object-contain" />
            <h1 className="font-display font-black text-3xl tracking-tight">Staff Sign in</h1>
            <p className="text-sm text-zinc-600 mt-1 font-medium">Manage careers opportunities for your school</p>
          </div>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] font-bold mb-1.5">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="brut-input"
                placeholder="you@school.edu"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] font-bold mb-1.5">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="brut-input"
                placeholder="••••••••"
                data-testid="login-password-input"
              />
            </div>

            {error && (
              <div className="border-2 border-black bg-[#FFE4E4] px-3 py-2 text-sm font-bold" data-testid="login-error">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="brut-btn-primary w-full"
              data-testid="login-submit"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
}
